export default __webpack_public_path__ + "static/media/light-violet-information.e559d9b4.svg";